import { render, staticRenderFns } from "./DeviceSummaryTable.vue?vue&type=template&id=38ad604a&scoped=true"
import script from "./DeviceSummaryTable.vue?vue&type=script&lang=js"
export * from "./DeviceSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./DeviceSummaryTable.vue?vue&type=style&index=0&id=38ad604a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad604a",
  null
  
)

export default component.exports